// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fSGw","top":"styles_top__1jMqf","left":"styles_left__3AlbE","description":"styles_description__2ylsG"};